import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import ProjectIcon from '@atlaskit/icon/core/project';
import LegacyProjectsIcon from '@atlaskit/legacy-custom-icons/project-icon';
export var ProjectsIcon = function ProjectsIcon(props) {
  return /*#__PURE__*/React.createElement(ProjectIcon, _extends({
    color: "var(--ds-icon, #44546F)",
    LEGACY_fallbackIcon: LegacyProjectsIcon,
    LEGACY_margin: "10px",
    spacing: "spacious"
  }, props));
};